module.exports = __webpack_public_path__ + "img/brand_text.37d5dcd7.svg";